import { driver } from 'driver.js';
import { tourFor, tourSeenKey } from './tours';

const OPEN_MENU = 'ambiental:open-menu';
const CLOSE_MENU = 'ambiental:close-menu';

let current = null;
let openedMenu = false;
let persistOnClose = true;
let beginTimer = 0;

export function elementIsShown(el) {
  if (!el || typeof window === 'undefined') return false;
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  const rect = el.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return false;
  // O menu mobile fica fora da tela com translate. Item abaixo da dobra continua válido.
  return rect.right > 8 && rect.left < window.innerWidth - 8;
}

export function stepsOnScreen(steps, query) {
  const find = query || ((selector) => document.querySelector(selector));
  return (steps || []).filter((step) => {
    if (!step?.element) return true;
    return elementIsShown(find(step.element));
  });
}

function readSeen(key) {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function writeSeen(key) {
  try {
    localStorage.setItem(key, '1');
  } catch {
    /* armazenamento indisponível */
  }
}

function ensureMenuOpen() {
  if (typeof window === 'undefined' || window.innerWidth >= 1024) return;
  window.dispatchEvent(new CustomEvent(OPEN_MENU));
  openedMenu = true;
}

function releaseMenu() {
  if (!openedMenu || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CLOSE_MENU));
  openedMenu = false;
}

function clearBeginTimer() {
  if (!beginTimer || typeof window === 'undefined') return;
  window.clearTimeout(beginTimer);
  beginTimer = 0;
}

export function destroyProductTour({ persist = false } = {}) {
  clearBeginTimer();
  const running = current;
  if (!running) {
    releaseMenu();
    return;
  }
  persistOnClose = persist;
  current = null;
  running.destroy();
  persistOnClose = true;
}

export function startProductTour({ user, tenant, force = false } = {}) {
  const tour = tourFor(user, tenant);
  if (!tour || typeof document === 'undefined') return false;
  const seenKey = tourSeenKey(user, tour.id);
  if (!force && readSeen(seenKey)) return false;

  destroyProductTour({ persist: false });
  ensureMenuOpen();

  const begin = () => {
    const steps = stepsOnScreen(tour.steps);
    if (steps.length < 2) {
      releaseMenu();
      return;
    }
    current = driver({
      animate: true,
      smoothScroll: true,
      allowClose: true,
      overlayOpacity: 0.55,
      stagePadding: 6,
      stageRadius: 8,
      showProgress: true,
      progressText: '{{current}} de {{total}}',
      nextBtnText: 'Próximo',
      prevBtnText: 'Anterior',
      doneBtnText: 'Concluir',
      popoverClass: 'ambiental-tour',
      steps,
      onHighlightStarted: (element) => {
        if (element && typeof element.scrollIntoView === 'function') {
          element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      },
      onDestroyed: () => {
        current = null;
        if (persistOnClose) writeSeen(seenKey);
        releaseMenu();
      },
    });
    current.drive();
  };

  if (openedMenu) {
    beginTimer = window.setTimeout(() => {
      beginTimer = 0;
      begin();
    }, 400);
  } else {
    begin();
  }
  return true;
}
